import { render, staticRenderFns } from "./FunctionManage.vue?vue&type=template&id=4fd2b118&scoped=true"
import script from "./FunctionManage.vue?vue&type=script&lang=js"
export * from "./FunctionManage.vue?vue&type=script&lang=js"
import style0 from "./FunctionManage.vue?vue&type=style&index=0&id=4fd2b118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd2b118",
  null
  
)

export default component.exports